import { GoogleOAuthProvider } from '@react-oauth/google';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../../../hooks/store';
import { getIsMobile } from '../../../../redux/selectors';
import config from '../../../../system/config';
import { AuthUniInfo } from './AuthUniInfo';
export var AuthFormWrapper = function () {
    var isMobile = useAppSelector(getIsMobile);
    return (React.createElement(GoogleOAuthProvider, { clientId: config.google_id },
        React.createElement("div", { className: "bg-gradient-to-r from-[#FFDAC7] to-[#CFE0FA] h-dvh overflow-hidden" }, isMobile ? (React.createElement(Outlet, null)) : (React.createElement("div", { className: "flex h-full w-full items-center justify-center" },
            React.createElement("div", { className: "grid grid-cols-[30rem_1fr] min-h-[58rem] p-3.5 bg-white rounded shadow-md w-full max-w-[90rem]" },
                React.createElement(AuthUniInfo, null),
                React.createElement(Outlet, null)))))));
};
